import React from 'react'
import cn from 'classnames'
import styles from './Banner.module.sass'
import { useTranslation } from 'react-i18next'

const EarnLikeBanner = () => {
  const { t } = useTranslation()

  return (
    <div className={cn('section', styles.banner)}>
      <div className={styles.content}>
        <div className={cn('h2', styles.title)}>
          {t('Earn Like Never Before!')}
        </div>
        <div className={styles.subTitle}>
          {t('Join the FiniticX Affiliate Program today and Gain up to')}
          <b> {t('50% commission')} </b>
          {t('on each referral')}
        </div>
        <button className={styles.button}>{t('Join Affiliate Program')}</button>
      </div>
      <img
        className={styles.img}
        src="/images/content/crypto/new-crypto-images/earn-like-never-banner.png"
      />
    </div>
  )
}

export default EarnLikeBanner
